import { css } from 'emotion';

// Icons
import playIcon from '../icons/play.svg';
import pauseIcon from '../icons/pause.svg';
import separateIcon from 'icons/separate.svg';

const icons = {
  play: playIcon,
  pause: pauseIcon,
  separate: separateIcon,
};

export const svgStyle = css`
  position: absolute;
  bottom: 0;
  left: 0;
`;

export const dragSvgStyle = css`
  position: absolute;
  height: 25%;
  width: 100%;
  bottom: 0;
  left: 0;
`;

export const textStyle = css`
  font-size: 11pt;
`;

export const legendStyle = css`
  transform-origin: top right;
  position: absolute;
  top: 8.5%;
  left: 0px;
  width: 270px;
  line-height: 2em;
  @media (max-width: 768px) and (orientation: portrait) {
    width: 160px;
    line-height: 1.2em;
  }
  & .item {
    display: inline-block;
    margin: 0px 15px;
    vertical-align: baseline;
    @media (max-width: 768px) and (orientation: portrait) {
      margin: 0px 9px;
    }
    & .box {
      display: inline-block;
      width: 15px;
      height: 15px;
      margin-right: 5px;
      border-radius: 50%;
      transform: translateY(2px);
      @media (max-width: 768px) and (orientation: portrait) {
        width: 9px;
        height: 9px;
        margin-right: 3px;
      }
    }
    & text {
      font-size: 1rem;
      @media (max-width: 768px) and (orientation: portrait) {
        font-size: 0.6rem;
      }
    }
  }
`;

export const buttonContainerStyle = css`
  position: absolute;
  right: 0px;
  top: 8.5%;
  max-width: 200px;
`;

export const buttonStyle = (props) => css`
  background: #f6274e url(${icons[props]}) no-repeat center center;
  background-size: contain;
  display: inline-block;
  border: none;
  padding: 1.7rem 1.7rem;
  margin: 0.2rem;
  border-radius: 1.7rem;
  color: #ffffff;
  cursor: pointer;
  transition: background-color 250ms ease-in-out,
              transform 150ms ease;

  &:hover,
  &:focus {
      background-color: #ed113a;
      transform: translateY(-1px);
  }

  &:focus {
      outline: 1px solid #fff;
      outline-offset: -4px;
  }

  &:active {
      transform: scale(0.99);
  }

  @media (max-width: 800px) {
    padding: 0.9rem 0.9rem;
    border-radius: 0.9rem;
  }
`;

export const textButtonStyle = css`
  display: inline-block;
  width: 110px;
  margin: 10px;
  font-size: 1rem;

  @media (max-width: 800px) {
    width: 60px;
    margin: 5px;
    font-size: 0.6rem;
  }
`;

export const tooltipStyle = css`
  color: white;
  padding: 10px 15px;
  background: #2F363F;
  position: absolute;
  opacity: 0;
  visibility: visible;
  line-height: 1.4;
  font-weight: 300;
  font-size: 16px;
  box-shadow: 0px 0px 3px #2F363F;
  max-width: 300px;
  text-align: center;
  border-radius: 4px;
  pointer-events: none;
`;

export const loadingStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  & span {
    font-family: 'Open Sans';
    font-size: 20pt;
    font-weight: 300;
    color: white;
    position: relative;
    float: left;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
